var exports = {
  "kL": "FormSwitch.module__container___bzNqcz",
  "oE": "FormSwitch.module__compact___bzNqcz",
  "_A": "FormSwitch.module__labelContainer___bzNqcz",
  "Pf": "FormSwitch.module__label___bzNqcz",
  "r9": "FormSwitch.module__disabled___bzNqcz",
  "vk": "FormSwitch.module__clickable___bzNqcz",
  "h_": "FormSwitch.module__description___bzNqcz",
  "HV": "FormSwitch.module__switchRoot___bzNqcz",
  "L8": "FormSwitch.module__switchThumb___bzNqcz",
  "nL": "FormSwitch.module__iconChecked___bzNqcz",
  "ao": "FormSwitch.module__iconUnchecked___bzNqcz",
};

module.exports = exports;
